import { Component, OnInit, Optional } from "@angular/core"; import { Location } from "@angular/common";
import { BaseComponent } from '../../base/base-component';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { ProfilService } from '../../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../../app.main.component';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { NonConformiteService } from '../../services/non-conformite-service';
import { MessageService } from 'primeng/api';
import { NonConformiteEntite } from '../../entites/non-conformite';
import { EmplacementService } from '../../services/emplacement-service';
import { CodeProjetEntite } from '../../entites/code-projet';
import { FournisseurService } from '../../services/fournisseur-service';
import { Fournisseur } from '../../entites/fournisseur';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { EmployeEntite } from "src/app/entites/employe";
import { EmployeService } from "src/app/services/employe-service";

@Component({
    selector: 'app-ajout-non-conformite',
    templateUrl: './ajout-non-conformite.component.html',
    providers: [MessageService, NonConformiteService]
})
export class AjoutNonConformiteComponent extends BaseComponent implements OnInit {
    nonConformite: NonConformiteEntite;
    submitted: boolean;
    codeProjets: CodeProjetEntite[];
    codeProjetFiltres: CodeProjetEntite[];
    fournisseurs: Fournisseur[];
    responsables: string[];
    objets: string[];
    autreObjet: string;
    autreResponsable: string;
    filtreProjetActif: boolean = true;

    employes: EmployeEntite[];

    submitting: boolean = false;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        routerService: Router,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private nonConformiteService: NonConformiteService,
        private messageService: MessageService,
        private EmplacementService: EmplacementService,
        private FournisseurService: FournisseurService,
        private EmployeService: EmployeService,
        @Optional() private ref: DynamicDialogRef,
    ) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Non-conformités', routerLink: '/assurancequalite/nonconformite' },
            { label: 'Ajouter' }
        ]);
    }

    ngOnInit() {
        this.nonConformite = {
            idNonConformite: null,
            numero: null,
            entrepreneur: "Hamel Construction",
            responsableQualite: null,
            sousTraitant: null,
            representantSousTraitant: null,
            client: null,
            representantClient: null,
            objet: null,
            responsable: null,
            causesPossibles: null,
            statut: null,
            conversationId: null,
            codeProjet: {
                code: null,
                nom: null
            },
            type: null,
            dateEmission: new Date(),
            dateDetection: null,
            description: null,
            titre: null,
            traitementPropose: null,
            approbation: null,
            approbationConditions: null,
            dossierSst: null,
            coordonateur: null,
            employe: this.profilService.ProfilCourant(),
            actionsCorrectives: []
        };

        var promises = [];

        promises.push(this.EmplacementService.ObtenirCodeProjets().then(
            (result) => {
                this.codeProjets = result.valeur;

                if (this.profilService.ProfilCourant().emplacementIdsResponsable.length > 0 || this.profilService.ProfilCourant().emplacementIdsCP.length > 0) {
                    this.filtreProjetActif = true;
                    let projetsResponsable = this.sdb.Emplacements().filter(e => this.profilService.ProfilCourant().emplacementIdsResponsable.includes(e.emplacementId) && e.codeProjet).map(e => e.codeProjet.codeProjetId);
                    let projetsCP = this.sdb.Emplacements().filter(e => this.profilService.ProfilCourant().emplacementIdsCP.includes(e.emplacementId) && e.codeProjet).map(e => e.codeProjet.codeProjetId);
                    this.codeProjetFiltres = this.codeProjets.filter(cp => projetsResponsable.includes(cp.codeProjetId) || projetsCP.includes(cp.codeProjetId));

                    if (this.codeProjetFiltres.length == 1) {
                        this.nonConformite.codeProjet = this.codeProjetFiltres[0];
                    }
                } else {
                    this.filtreProjetActif = false;
                    this.codeProjetFiltres = this.codeProjets;
                }
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération du code projet' });
            }
        ));

        promises.push(this.FournisseurService.ObtenirFournisseurs().then(
            (result) => {
                this.fournisseurs = result.valeur;
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des fournisseurs' });
            }
        ));

        this.EmployeService.ObtenirListe().then(
            (result) => {
                this.employes = result.valeur;
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des employés' });
            }
        );

        Promise.all(promises).then(() => {
            this.CompleterChargement();
        });

        this.responsables = ['Client', 'Entrepreneur', 'Fournisseur', 'Sous-traitant'];
        this.objets = ['Contrat', 'Produit/Matériel', 'Processus', 'Équipement', 'Transport'];
    }

    creerNonConformite() {
        if (!this.valider()) { return; }

        this.submitting = true;
        this.submitted = true;

        this.nonConformite.objet = this.nonConformite.objet == 'Autre' ? this.autreObjet : this.nonConformite.objet;
        this.nonConformite.responsable = this.nonConformite.responsable == 'Autre' ? this.autreResponsable : this.nonConformite.responsable;

        this.nonConformiteService.Creer(this.nonConformite).then(
            (result) => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Non-conformité ajoutée avec succès' });
                this.routerService.navigate(['/assurancequalite/nonconformite/' + result.valeur.idNonConformite]);
                this.ref.close(result.valeur);
                this.submitting = false;
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de l\'ajout de la non-conformité' });
                this.submitting = false;
            }
        );
    }

    toggleFiltreProjet() {
        this.filtreProjetActif = !this.filtreProjetActif;
        if (this.filtreProjetActif) {
            this.codeProjetFiltres = this.codeProjets.filter(cp => this.profilService.ProfilCourant().emplacementIdsResponsable.includes(cp.codeProjetId) || this.profilService.ProfilCourant().emplacementIdsCP.includes(cp.codeProjetId));
        } else {
            this.codeProjetFiltres = this.codeProjets;
        }
    }

    surChangementCodeProjet() {
        if (this.nonConformite.codeProjet?.codeProjetId && this.nonConformite.codeProjet?.client) {
            this.nonConformite.client = this.nonConformite.codeProjet.client.nom;
        }
    }

    valider(): boolean {
        if (!this.nonConformite.type) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Le type est obligatoire' });
            return false;
        }
        if (!this.nonConformite.codeProjet) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Le code projet est obligatoire' });
            return false;
        }
        if (!this.nonConformite.titre) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Le titre est obligatoire' });
            return false;
        }
        if (!this.nonConformite.dateDetection) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'La date de détection est obligatoire' });
            return false;
        }
        if (!this.nonConformite.objet && !this.autreObjet) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'objet est obligatoire' });
            return false;
        }
        if (!this.nonConformite.responsable && !this.autreResponsable) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Le responsable est obligatoire' });
            return false;
        }
        if (!this.nonConformite.coordonateur) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Le coordonnateur est obligatoire' });
            return false;
        }
        return true;
    }

    copierDateEmission() {
        if (this.nonConformite.dateEmission) {
            this.nonConformite.dateDetection = new Date(this.nonConformite.dateEmission);
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Date de détection copiée' });
        } else {
            this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Veuillez d\'abord sélectionner une date d\'émission' });
        }
    }
}